import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { errMsg } from "../lib/api";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { loginGoogleSession } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id") || "";
    loginGoogleSession(sid)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => setError(errMsg(e)));
  }, [hash, loginGoogleSession, navigate]);

  return (
    <div className="min-h-screen grid place-items-center p-6 text-sm" data-testid="auth-callback">
      {error ? (
        <div className="max-w-sm text-center space-y-3">
          <p className="rounded-md border border-red-300 bg-red-50 px-3 py-2 text-red-700" data-testid="auth-callback-error">{error}</p>
          <button type="button" className="text-primary font-semibold" onClick={() => navigate("/login", { replace: true })}>Kembali ke halaman masuk</button>
        </div>
      ) : (
        <p className="text-muted-foreground">Memverifikasi akun Google…</p>
      )}
    </div>
  );
}
